module.exports = __webpack_public_path__ + "static/media/gold.43f8e546.png";